module.exports = "/_next/static/images/bg-services-639cbdb7fcc5aebdcfd43092ec7a28b8.png.webp";